// extracted by mini-css-extract-plugin
export default {"container":"TopicIdPage_container__lLszd"};